export default __webpack_public_path__ + "static/media/deleteImage.97ad0478.svg";